'use client';

import { CheckIcon } from 'lucide-react';
import { Indicator, Root } from '@radix-ui/react-checkbox';

import type { ComponentProps } from 'react';

import { cn } from '~/utils';

export function Checkbox({ className, ...props }: ComponentProps<typeof Root>) {
  return (
    <Root
      data-slot='checkbox'
      className={cn(
        'peer border-input dark:bg-input/30 focus-visible:border-ring focus-visible:ring-ring/50',
        'data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        'border-0 bg-blueBonnet-50 data-[state=checked]:bg-cottonBoll-600 size-3 rounded-[2px] overflow-hidden',
        className,
      )}
      {...props}
    >
      <Indicator
        data-slot='checkbox-indicator'
        className='flex items-center justify-center text-current transition-none'
      >
        <CheckIcon className='size-3.5 absolute' color='#ffffff' />
      </Indicator>
    </Root>
  );
}
